import React from 'react';
import {isPRD} from '../../../../utlis/vars';
import {FmText} from '../../types/types';
import './style.scss';

const Title = ({
                 children: text,
                 color = 'black',
                 weight = 'normal',
                 size = 'lg',
                 lineHeight = 'md',
                 className = '',
                 id,
                 style,
                 'data-testid': dataTestId
               }: FmText): React.ReactElement => {
  return (
    <h1
      id={id}
      data-testid={isPRD ? undefined : dataTestId}
      className={`fm-title fm-color-${color} fm-fw-${weight} fm-lh-${lineHeight} fm-fs-${size}${
        className ? ` ${className}` : ''
      }`}
      style={style}
    >
      {text}
    </h1>
  );
};

export default Title;
